// extracted by mini-css-extract-plugin
export default {"contentWrapper":"styles_contentWrapper__z4xgm"};